import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface Props {
  alignItems?: string;
  children: any,
  height?: string;
  style?: CSSProperties;
  className?: string;
  onDoubleClick?: () => void;
}

const Row = (props: Props) => {
  const {
    alignItems,
    children,
    height,
    style,
    className,
    onDoubleClick,
  } = props;

  const styles: CSSProperties = {
    alignItems: alignItems ?? 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    minHeight: height,
    padding: '4px 0px',
    width: '100%',
    ...style,
  };
  return (
    <div style={styles} className={className} onDoubleClick={onDoubleClick}>
      {children}
    </div>
  );
};

export default Row;
